/**
 * @ngdoc Controller
 * @name ActivityFeedController
 */

(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('AdminVenusGrafanaInstancesController', AdminVenusGrafanaInstancesController);

    /**
     * @constructor
     * @ngInject
     */
    function AdminVenusGrafanaInstancesController($log, $scope, AdminTableService) {
        $log.info('AdminVenusGrafanaInstancesController');
        $scope.table = new AdminTableService("venus-grafana-instances");
    }
})();
